import {inject, injectable} from 'inversify';

import type {CourseModel} from '../../domain/Course/Course.model';
import type {DateTimeModel} from '../../domain/Date/DateTime.model';
import type {GoalModel} from '../../domain/Goal/Goal.model';

import {logger} from '../../../utils/logger';
import {CreateCourseCmd} from '../../ports/Course/CreateCourse/CreateCourse.cmd';
import {CreateGoalsInCourseCmd} from '../../ports/Goal/CreateGoalsInCourse/CreateGoalsInCourse.cmd';

@injectable()
export class CreateCourseUseCase {
  constructor(
    @inject(CreateCourseCmd)
    private readonly createCourseCmd: CreateCourseCmd,
    @inject(CreateGoalsInCourseCmd)
    private readonly createGoalsInCourseCmd: CreateGoalsInCourseCmd,
  ) {}

  async exec({
    goals,
    label,
    programId,
    startDate,
  }: CreateCourseUseCase.Props): Promise<CreateCourseUseCase.Response> {
    try {
      const course = await this.createCourseCmd.exec({
        label,
        programId,
        startDate,
      });

      let createdGoals: GoalModel[] = [];

      if (goals?.length) {
        createdGoals = await this.createGoalsInCourseCmd.exec({
          courseId: course.id,
          goals,
          programId,
        });
      }

      logger.event('squad_create_success');

      return {
        course,
        goals: createdGoals,
      };
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace CreateCourseUseCase {
  export type Props = {
    goals?: GoalModel[];
    label?: string;
    programId: string;
    startDate: DateTimeModel;
  };
  export type Response = {
    course: CourseModel;
    goals: GoalModel[];
  };
}
